import { stateGo } from 'redux-ui-router';
import { selectWeek } from 'logic/product';

import {
  fetchMember,
  selectMember,
  selectMemberLevel,
  selectPrintTooltip,
  selectSubscription,
  selectIsProductLowFodmap,
  selectIsProductWithRequirements,
} from 'logic/member';

import {
  activateMealPlan,
  cloneMealPlan,
  deactivateMealPlan,
  fetchMealPlan,
  fetchMealPlanActive,
  fetchMealPlansMine,
  deleteMeal,
  deleteMealPlan,
  selectDays,
  selectMealPlan,
  selectMealPlanPdfs,
  selectMealPlanIsClone,
  selectMealsHasCookup,
  selectPageForMealPlanId,
} from 'logic/mealPlan';

export const MealPlan = {
  template: `
    <div class="meal-plan">
      <main class="main-content border border-y bg-gray-100 pt-3 pb-5">
        <div class="container mb-3">
          <div class="row">
            <div class="col-md-10 mx-auto">
              <div class="meal-plan-meta"
                ng-hide="$ctrl.isLoading">
                <div class="alert alert-warning"
                  ng-if="$ctrl.isProductRequirements">
                  Please be aware that if you choose to swap recipes into your plan, they may not be suitable for
                  {{ $ctrl.isProductLowFodmap ? "Low FODMAP" : "your Program's" }}
                  dietary requirements, and you will need to adapt ingredients accordingly.
                </div>
                <div class="d-md-flex justify-content-between align-items-center flex-row-reverse mb-3">
                  <div class="text-right mb-2 mb-md-0">
                    <meal-plan-print
                      pdfs="$ctrl.pdfs"
                      ng-hide="true"
                      level="$ctrl.level"
                      tooltip="$ctrl.tooltip"
                      ng-click="$ctrl.refetchMember()"
                      ng-if="$ctrl.subscription.canPrint">
                    </meal-plan-print>
                  </div>
                  <div class="d-flex align-items-center justify-content-between">
                    <button class="btn btn-pill bg-cz-theme text-white"
                      type="button"
                      ng-show="$ctrl.isClone"
                      ng-click="$ctrl.onEdit($ctrl.mealPlan.id, $ctrl.level, $ctrl.week.id)">
                      <i class="fa fa-lg icon-pencil text-white"></i>
                      Edit Meal Plan
                    </button>
                    <button class="btn btn-pill bg-cz-theme text-white"
                      type="button"
                      ng-hide="$ctrl.isClone"
                      ng-click="$ctrl.onClone($ctrl.mealPlan.id, $ctrl.subscription.id, $ctrl.level, $ctrl.week.id)">
                      <i class="fa fa-lg icon-pencil text-white"></i>
                      <span ng-hide="$ctrl.isCreating">Edit</span>
                      <span ng-show="$ctrl.isCreating">
                        <spinner is-loading="$ctrl.isCreating">Saving</spinner>
                      </span>
                      Meal Plan
                    </button>
                    <span class="d-block d-sm-inline pl-1 pl-sm-3"
                      ng-hide="$ctrl.weekNumber">
                      <button class="btn btn-pill bg-cz-theme text-white"
                        type="button"
                        ng-hide="$ctrl.mealPlan.id === $ctrl.active"
                        ng-click="$ctrl.activateMealPlan($ctrl.mealPlan.id)">
                        <spinner is-loading="$ctrl.isActivating">
                          Add to Dashboard
                        </spinner>
                      </button>
                      <button-link
                        ng-show="$ctrl.mealPlan.id === $ctrl.active"
                        ng-click="$ctrl.deactivateMealPlan($ctrl.mealPlan.id)">
                        <spinner is-loading="$ctrl.isActivating">
                          <span class="font-size-small font-size-md-base">
                            Remove from Dashboard
                          </span>
                        </spinner>
                      </button-link>
                    </span>
                  </div>
                </div>
                <div class="mb-3" ng-show="$ctrl.hasCookup">
                  <meal-plan-cook-more></meal-plan-cook-more>
                </div>
              </div>
              <div class="d-md-flex mb-4"
                ng-repeat="day in $ctrl.days track by $index">
                <div class="meal-plan-day pr-md-4 text-center">
                  <meal-plan-day-icon count="day.meals.length" is-active="true">
                    <span ng-show="$ctrl.week">
                      Day {{ $index + 1 }}
                    </span>
                    <span ng-hide="$ctrl.week">
                      {{ day.dayString | limitTo: 3 }}
                    </span>
                  </meal-plan-day-icon>
                  <small class="meal-plan-day-cals d-block text-purple-cz-mid font-weight-semibold mt-md-1">
                    {{ day.calories }} Cal
                  </small>
                </div>
                <div class="meal-plan-recipes">
                  <div class="bg-white"
                    ng-repeat="meal in day.meals track by $index">
                    <meal-plan-recipe
                      meal="meal"
                      is-active="$ctrl.isClone"
                      on-preview="$ctrl.onPreview(recipe)"
                      on-remove="$ctrl.deleteMeal($ctrl.mealPlan.id, meal.id, day.day)">
                    </meal-plan-recipe>
                  </div>
                  <div class="bg-white h-100 d-flex justify-content-center align-items-center"
                    ng-show="day.meals.length === 0">
                    <strong>
                      No meals added for
                      <span ng-show="$ctrl.week">day {{ $index + 1 }}</span>
                      <span ng-hide="$ctrl.week">{{ day.dayString }}</span>
                    </strong>
                  </div>
                </div>
              </div>
              <div class="text-right mr-md-3" ng-show="$ctrl.isClone">
                <button-link ng-click="$ctrl.onDelete($ctrl.mealPlan.id, $ctrl.subscription.id, $ctrl.week.id)">
                  <span class="text-warning">
                    <i class="fa fa-times-circle"></i>
                    Delete <span ng-show="$ctrl.week">custom</span> meal plan
                  </span>
                </button-link>
              </div>
            </div>
          </div>
        </div>
        <recipe-preview
          recipe-id="$ctrl.recipePreviewId"
          show-on="$ctrl.recipePreviewShow">
        </recipe-preview>
      </main>
    </div>`,

  controller($anchorScroll, $ngRedux, $state, $timeout) {
    'ngInject';

    return {
      $onInit() {
        const connect = $ngRedux.connect(this.mapState, this.mapDispatch());
        this.disconnect = connect(this);
        $anchorScroll();

        if (!this.mealPlan.recipes) {
          this.fetchMealPlan(this.mealPlanId, this.level);
        }

        if (!this.active) {
          this.fetchMealPlanActive();
        }
      },

      $onDestroy() {
        this.disconnect();

        if (this.unsubscribe) {
          this.unsubscribe();
        }
      },

      onClone(mealPlanId, subscriptionId, level, weekId) {
        this.unsubscribe = $ngRedux.subscribe(() =>
          this.unsubscribeOnClone(level, weekId)
        );

        this.cloneMealPlan(mealPlanId, subscriptionId, weekId);
      },

      onDelete(mealPlanId, subscriptionId, weekId) {
        this.unsubscribe = $ngRedux.subscribe(() =>
          this.unsubscribeOnDelete(mealPlanId, subscriptionId, weekId)
        );

        this.deleteMealPlan(mealPlanId);
      },

      onEdit(mealPlanId, level, weekId, hardReload) {
        const day = 'Monday';
        const path = weekId
          ? 'program.week.mealPlan.edit'
          : 'nutrition.mealPlans.detail.edit';

        // TODO: do a hard redirect to edit, due to some issues with the state
        // updating and a race condition.
        hardReload
          ? window.location.assign(
              $state.href(path, { day, level, mealPlanId })
            )
          : this.stateGo(path, { day, level, mealPlanId });
      },

      onPreview(recipe) {
        this.recipePreviewId = recipe.id;
        this.recipePreviewShow = true;
        $timeout(() => (this.recipePreviewShow = false));
      },

      refetchMember() {
        this.tooltip && $timeout(() => this.fetchMember(this.member.id), 500);
      },

      unsubscribeOnClone(level, weekId) {
        const { result } = $ngRedux.getState().mealPlan;

        if (result) {
          this.unsubscribe();
          this.onEdit(result, level, weekId, true);
        }
      },

      unsubscribeOnDelete(mealPlanId, subscriptionId, weekId) {
        const { mealPlan } = $ngRedux.getState();
        const isDeleted = !selectMealPlan(mealPlan, mealPlanId).id;

        if (isDeleted) {
          this.unsubscribe();

          // TODO: do a hard redirect to edit, due to some issues with the state
          // updating and a race condition.
          window.location.assign(
            $state.href(weekId ? 'program.week' : 'nutrition.mealPlans', {
              type: 'mine',
            })
          );

          // const page = selectPageForMealPlanId(mealPlan, mealPlanId, 'mine');
          // this.fetchMealPlansMine(subscriptionId, page, weekId);
          // this.stateGo(weekId ? 'program.week' : 'nutrition.mealPlans');
        }
      },

      mapState({ mealPlan, member, product, router }) {
        const { mealPlanId, voomeProductId, weekNumber } = router.currentParams;
        const { active, isActivating, isCreating, isLoading } = mealPlan;
        const subscription = selectSubscription(member);

        return {
          active,
          isActivating,
          isCreating,
          isLoading,
          mealPlanId,
          subscription,
          voomeProductId,
          weekNumber,
          tooltip: selectPrintTooltip(member),
          member: selectMember(member),
          days: selectDays(mealPlan, mealPlanId),
          hasCookup: selectMealsHasCookup(mealPlan, mealPlanId),
          isClone: selectMealPlanIsClone(mealPlan, mealPlanId),
          level: selectMemberLevel(member),
          mealPlan: selectMealPlan(mealPlan, mealPlanId),
          pdfs: selectMealPlanPdfs(mealPlan, mealPlanId, subscription.id),
          week: selectWeek(product, weekNumber),
          isProductLowFodmap: selectIsProductLowFodmap(member, voomeProductId),
          isProductRequirements: selectIsProductWithRequirements(
            member,
            voomeProductId
          ),
        };
      },

      mapDispatch() {
        return {
          activateMealPlan,
          cloneMealPlan,
          deactivateMealPlan,
          fetchMember,
          fetchMealPlan,
          fetchMealPlanActive,
          fetchMealPlansMine,
          deleteMeal,
          deleteMealPlan,
          stateGo,
        };
      },
    };
  },
};



// WEBPACK FOOTER //
// ./src/containers/MealPlan.js